const actions = {
  SET_STATE: 'comment/SET_STATE',
  GET_COMMENTS: 'comment/GET_COMMENTS',
  APPROVE_COMMENT: 'comment/APPROVE_COMMENT',
}

export default actions
